// Entry point for the build script in your package.json

import "@hotwired/turbo-rails";
import "iconify-icon";

import "./channels";
import "./controllers";

function showLoader(event) {
  // Turbo prefetch (hover) fires this same event; skip it so the loader
  // only appears for actual navigations/submissions.
  if (event.detail.fetchOptions.headers["X-Sec-Purpose"] === "prefetch") return;

  document.querySelector(".loader-wrapper")?.classList.remove("hidden");
}

function hideLoader() {
  document.querySelector(".loader-wrapper")?.classList.add("hidden");
}

document.addEventListener("turbo:before-fetch-request", showLoader);
document.addEventListener("turbo:load", hideLoader);
document.addEventListener("turbo:submit-end", hideLoader);
document.addEventListener("turbo:frame-render", hideLoader);
window.addEventListener("pageshow", hideLoader);

// Turbo.setProgressBarDelay(0)
